import { FieldInstruction } from 'containers/FormBuilder'
import InputField from 'form/fieldComponents/InputField'
import { normalizeNameFormatFn as formatFn } from 'form/fields/utils/nameFieldUtils'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

const vehicleVin: FieldInstruction<typeof InputField> = {
    Component: InputField,
    config: {
        label: 'VIN / HIN',
        validator: Yup.string()
            .matches(
                /^(\w{17}|\w{12}|\w{7})$/,
                'VIN must be 7, 12, or 17 alphanumeric characters', // eslint-disable-line max-len
            )
            .required(FIELD_REQUIRED),
        formatFn,
    },
}

export default vehicleVin
